import React, { Component } from "react";
import Select from "react-select";
import { isMobile } from "react-device-detect";

const customStyles = {
  control: (provided, state) => ({
    // none of react-select's styles are passed to <Control />
    ...provided,
    width: "100%",
    borderWidth: "0px",
    borderBottomWidth: "0px",
    borderRadius: "0px"
  }),
  menu: base => ({
    ...base,
    zIndex: 100
  })
};

class SelectDropdownForGid extends Component {
  state = {
    searchVal: ""
  };
  render() {
    return (
      <Select
        isClearable
        onChange={this.handleChange}
        options={this.getOptions()}
        label={this.props.label}
        placeholder={this.props.placeholder}
        value={this.getValue()}
        styles={customStyles}
        defaultValue={""}
        theme={theme => ({
          ...theme,
          borderRadius: 0,
          colors: {
            ...theme.colors,
            primary: "blue"
          },
          borderBottomWidth: "0px",
          borderBottomColor: "blue"
        })}
        placeholder={this.props.title}
        isDisabled={this.props.disabled}
      />
    );
  }

  // handleInputChange = value => {
  //   console.log("yummy" + value);
  // };
  // handleChange = (value, option, complete) => {
  //   if (option || complete) return;
  //   console.log("handleChange " + JSON.stringify(value));
  //   this.props.stateHandler(value.value, "newVal", false);
  // };

  handleChange = (newValue, actionMeta) => {
    if (actionMeta.action === "clear") {
      this.props.stateHandler(
        "",
        this.props.stateFieldName,
        this.props.isPayload,
        this.props.arrayIndex
      );
    } else {
      if (newValue && newValue !== undefined) {
        this.props.stateHandler(
          newValue.value,
          this.props.stateFieldName,
          this.props.isPayload,
          this.props.arrayIndex
        );
        if (this.props.otherFields && this.props.otherFields.length > 0) {
          this.props.otherFields.map(item => {
            //console.log("auto update: " + JSON.stringify(item));
            let srcVal = newValue.fullRec[item.src];
            if (srcVal === undefined) {
              srcVal = "";
            }
            this.props.stateHandler(
              srcVal,
              item.tgt,
              this.props.isPayload,
              this.props.arrayIndex
            );
          });
        }
      }
    }
  };

  getOptions = () => {
    let newArray = [];
    if (!this.props.data && this.props.data === undefined) {
      //console.log("Data is undefined for SelectDropdown");
      return [];
    }

    //console.log("No of drop down records: " + this.props.data.length);
    for (let i = 0; i < this.props.data.length; i++) {
      let item = this.props.data[i];
      //console.log(JSON.stringify(this.props.filter));
      if (
        this.props.filter &&
        this.props.filter !== undefined &&
        this.props.filter.fieldVal &&
        this.props.filter.fieldVal !== ""
      ) {
        // console.log(
        //   "fieldName: " +
        //     this.props.filter.fieldName +
        //     "rec value: " +
        //     item[this.props.filter.fieldName] +
        //     "filter fieldVal: " +
        //     this.props.filter.fieldVal
        // );
        if (item[this.props.filter.fieldName] === this.props.filter.fieldVal) {
          newArray.push({
            value: item[this.props.fieldName],
            label: item[this.props.fieldName],
            fullRec: item
          });
        }
      } else {
        newArray.push({
          value: item[this.props.fieldName],
          label: item[this.props.fieldName],
          fullRec: item
        });
      }
    }

    return newArray;
  };

  getValue = () => {
    return { value: this.props.value, label: this.props.value };
  };
}

export default SelectDropdownForGid;



// WEBPACK FOOTER //
// ./src/app/components/Screens/FieldsComponents/SelectDropdown/SelectDropdownForGrid.jsx